module.exports = __webpack_public_path__ + "BradescoSans-Italic.b7c3a4d990c71ba1e919.woff";


//////////////////
// WEBPACK FOOTER
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/assets/fonts/BradescoSans/BradescoSans-Italic.woff
// module id = ../../../../../src/assets/fonts/BradescoSans/BradescoSans-Italic.woff
// module chunks = main